/**
 * UranIA PA — Cruscotto di piattaforma (`/admin/piattaforma` — era
 * `/console`, fusione A.5, "Riordino della mappa delle rotte" §4:
 * "contenuto buono, posizione sbagliata: diventa una sezione dell'hub e
 * cade la guardia aggiunta a mano"). Nessuna guardia per-rotta qui: il
 * segmento `(amministrazione)` la copre (`_amministrazione.tsx`), come
 * ogni altra rotta `/admin/*` in questo repo.
 *
 * §7.3 del documento "Riordino della mappa delle rotte" ("cosa vede
 * `tenant_admin`": nascondere config IdP/chiavi gateway/altri tenant, con
 * filtro *server-side* per `tenant_id`) resta fuori da questo passo —
 * richiede lavoro backend. Il documento stesso approva la guardia di
 * segmento come sufficiente per ora.
 *
 * Contenuto sostituito da "UranIA PA — Le 13 aree del cruscotto e i
 * pannelli di lavoro" (documento 4, precede questo file): 13 aree con
 * pannelli di lavoro al posto delle sole tabelle di lettura — vedi
 * `features/console/data/aree.ts` e `data/pannelli.ts`.
 *
 * `?vista=<id>`: una delle 3 viste storiche (stato/grafo/aiuto) o una
 * delle 13 aree. Un id sconosciuto riporta allo Stato piattaforma invece
 * di produrre una pagina vuota — la normalizzazione vive in
 * `ConsolePage.tsx`, non qui: `validateSearch` accetta qualunque stringa,
 * la pagina decide che cosa mostrarne.
 */

import { createRoute } from '@tanstack/react-router';

import { ConsolePage } from '../../../features/console/ConsolePage.tsx';
import { Route as AmministrazioneSegmentRoute } from '../../_amministrazione.tsx';

export const Route = createRoute({
  getParentRoute: () => AmministrazioneSegmentRoute,
  path: '/admin/piattaforma',
  validateSearch: (search: Record<string, unknown>): { vista: string } => ({
    vista: typeof search.vista === 'string' ? search.vista : 'stato',
  }),
  component: ConsolePage,
});
